/*  ========================================================================
    # Section - Slider
    ========================================================================  */

import React, { useEffect, useState } from 'react';

const Slider = ({ content, images }) => {
  const [activeSlide, setActiveSlide] = useState(0);

  /**
   * Check if sliding to the left should be possible.
   */
  const canSlideLeft = () => {
    if (activeSlide === 0) return false;
    return true;
  };

  /**
   * Check if sliding to the right should be possible.
   */
  const canSlideRight = () => {
    if (activeSlide + 1 < images.length) return true;
    return false;
  };

  /**
   * Handle slide to left.
   */
  const slideLeft = () => {
    if (canSlideLeft()) {
      setActiveSlide(prev => prev - 1);
    } else {
      setActiveSlide(images.length - 1);
    }
  };

  /**
   * Handle slide to right.
   */
  const slideRight = () => {
    if (canSlideRight()) {
      setActiveSlide(prev => prev + 1);
    } else {
      setActiveSlide(0);
    }
  };

  /**
   * Set active slide index to 0 on window resize.
   */
  useEffect(() => {
    window.addEventListener(
      'resize',
      () => {
        setActiveSlide(0);
      },
      { passive: true }
    );
  }, []);

  return (
    <div className='p-landing__container'>
      <div className='p-landing__row' style={{ '--active-slide': activeSlide }}>
        <div className='p-landing__col s-slider__content'>
          <div className='p-landing__wysiwyg-block' dangerouslySetInnerHTML={{ __html: content }} />
        </div>

        <div className='p-landing__col s-slider__images-wrapper'>
          <div className='s-slider__images-inner'>
            <div
              className='s-slider__images-axis'
              style={{
                transform: 'translateX(calc((-100% / 1 * var(--active-slide)))'
              }}
            >
              {images.map((image, index) => (
                <figure
                  key={`image-${index}`}
                  className='s-slider__image'
                  style={{ opacity: index === activeSlide ? 1 : 0.2 }}
                >
                  <img src={image.image.sizes.large} alt={image.image.alt} />
                </figure>
              ))}
            </div>
            <div className='s-slider__controls'>
              <button
                type='button'
                className='s-slider__controls-button'
                onClick={() => slideLeft()}
              >
                <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 14' fill='none'>
                  <path
                    d='M6.82849 1.34303L1.17163 6.99988L6.82849 12.6567'
                    stroke='#ffffff'
                    strokeWidth='1.5'
                  />
                </svg>
              </button>
              <div className='s-slider__controls-dots'>
                {images.map((image, index) => (
                  <span
                    key={`dot-${index}`}
                    style={{ backgroundColor: index === activeSlide ? '#0068a6' : '#d8e3eb' }}
                    onClick={() => setActiveSlide(index)}
                  />
                ))}
              </div>
              <button
                type='button'
                className='s-slider__controls-button'
                onClick={() => slideRight()}
              >
                <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 14' fill='none'>
                  <path
                    d='M1.17151 1.34303L6.82837 6.99988L1.17151 12.6567'
                    stroke='#ffffff'
                    strokeWidth='1.5'
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slider;
